import { 
  UPDATE_WELCOME_LOGIN_MODAL, 
  CLEAR_CSRF, 
  FETCH_GENAI_CONTENT_REQUEST, 
  FETCH_GENAI_CONTENT_SUCCESS, 
  FETCH_GENAI_CONTENT_FAILURE, 
  FETCH_BLACKBELT_CONTENT_REQUEST, 
  FETCH_BLACKBELT_CONTENT_SUCCESS, 
  FETCH_BLACKBELT_CONTENT_FAILURE,
  FETCH_AGENTICAI_CONTENT_REQUEST,
  FETCH_AGENTICAI_CONTENT_SUCCESS,
  FETCH_AGENTICAI_CONTENT_FAILURE
} from '../Contants/index';

// Login actions
export const updateWelcomeLoginModal = (data) => ({
    type: UPDATE_WELCOME_LOGIN_MODAL,
    payload: data,
});

export const clearCSRF = () => ({
    type: CLEAR_CSRF
});


// Actions for GenAiPinnacle 
export const fetchGenAIContentRequest = () => ({
    type: FETCH_GENAI_CONTENT_REQUEST,
});
  
export const fetchGenAIContentSuccess = (data) => ({
    type: FETCH_GENAI_CONTENT_SUCCESS,
    payload: data,
});
  
export const fetchGenAIContentFailure = (error) => ({
    type: FETCH_GENAI_CONTENT_FAILURE,
    payload: error,
});
  
export const fetchGenAIContent = (email) => {
    return (dispatch) => {
        dispatch(fetchGenAIContentRequest());
        const formData = new FormData();
        if(email){
            formData.append('query', `
                query MyQuery {
                    getPlatformJsonDataByName(platformName: "genaipinnacle",utmMedium: "${email}",pageLink: "${window.location.origin}${window.location.pathname}") {
                        platformData
                        platform {
                        platformName
                        }
                    }
                    getOfferByPlatformName(platformName: "genaipinnacle", email:"${email}") {
                        active
                        pointers
                        discountPercentage
                        discountEndDate
                        heading
                        discountHeadings
                        cta
                        text
                    }
                }
            ` );
        }
        else{
            formData.append('query', `
                query MyQuery {
                    getPlatformJsonDataByName(platformName: "genaipinnacle") {
                        platformData
                        platform {
                        platformName
                        }
                    }
                }
            ` );
        }
        formData.append('source', 'newmarketingpages');
        fetch(process.env.REACT_APP_GENAI_CONTENT,{
            method: 'POST',
            body:formData,
            credentials:"omit",
        })
        .then((response) => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data) => {
            dispatch(fetchGenAIContentSuccess(data));
        })
        .catch((error) => {
            dispatch(fetchGenAIContentFailure(error.message));
        });
        
    };
};


// Actions for Blackbelt 
export const fetchBlackbeltContentRequest = () => ({
    type: FETCH_BLACKBELT_CONTENT_REQUEST,
});
  
export const fetchBlackbeltContentSuccess = (data) => ({
    type: FETCH_BLACKBELT_CONTENT_SUCCESS,
    payload: data,
});
  
export const fetchBlackbeltContentFailure = (error) => ({
    type: FETCH_BLACKBELT_CONTENT_FAILURE,
    payload: error,
});
  
export const fetchBlackbeltContent = () => {
    return (dispatch) => {
        dispatch(fetchBlackbeltContentRequest());
        const formData = new FormData();
        formData.append('query', `
            query MyQuery {
            getPlatformJsonDataByName(platformName: "blackbelt") {
                platformData
                platform {
                platformName
                }
            }
            }
        ` );
        formData.append('source', 'newmarketingpages');
        fetch(process.env.REACT_APP_GENAI_CONTENT,{
            method: 'POST',
            body:formData,
            credentials:"omit"
        })
        .then((response) => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data) => {
            dispatch(fetchBlackbeltContentSuccess(data));
        })
        .catch((error) => {
            dispatch(fetchBlackbeltContentFailure(error.message));
        });
    };
};

// Actions for Agentic Ai
export const fetchAgenticAiContentRequest = () => ({
    type: FETCH_AGENTICAI_CONTENT_REQUEST,
});
  
export const fetchAgenticAiContentSuccess = (data) => ({
    type: FETCH_AGENTICAI_CONTENT_SUCCESS,
    payload: data,
});
  
export const fetchAgenticAiContentFailure = (error) => ({
    type: FETCH_AGENTICAI_CONTENT_FAILURE,
    payload: error,
});
  
export const fetchAgenticAiContent = () => {
    return (dispatch) => {
        dispatch(fetchAgenticAiContentRequest());
        const formData = new FormData();
        formData.append('query', `
            query MyQuery {
            getPlatformJsonDataByName(platformName: "agenticai") {
                platformData
                platform {
                platformName
                }
            }
            }
        ` );
        formData.append('source', 'newmarketingpages');
        fetch(process.env.REACT_APP_GENAI_CONTENT,{
            method: 'POST',
            body:formData,
            credentials:"omit"
        })
        .then((response) => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then((data) => {
            dispatch(fetchAgenticAiContentSuccess(data));
        })
        .catch((error) => {
            dispatch(fetchAgenticAiContentFailure(error.message));
        });
    };
};
